import { HotelFilterInputTypes, HotelFilterTypes, NonRefundableTypes } from '@shared/hotel-itinerary/hotel-filters';

export const NO_ZONE = 'NO_ZONE';
export const NO_ZONE_LABEL = 'HOTELS_MODULE.FILTER_HOTELS.NO_ZONE';
export const STAR_LABEL = 'HOTELS_MODULE.FILTER_HOTELS.STAR';
export const STARS_LABEL = 'HOTELS_MODULE.FILTER_HOTELS.STARS';

export const HOTEL_FILTERS_TYPES = {
  [HotelFilterTypes.Category]: HotelFilterInputTypes.Stars,
  [HotelFilterTypes.Zones]: HotelFilterInputTypes.Checkbox,
  [HotelFilterTypes.HotelPriceRanges]: HotelFilterInputTypes.Checkbox,
  [HotelFilterTypes.Price]: HotelFilterInputTypes.Range,
  [HotelFilterTypes.NonRefundable]: HotelFilterInputTypes.Checkbox,
  [HotelFilterTypes.Ammenities]: HotelFilterInputTypes.Checkbox,
  [HotelFilterTypes.HotelName]: HotelFilterInputTypes.Input,
  [HotelFilterTypes.Tags]: HotelFilterInputTypes.Checkbox,
  [HotelFilterTypes.Boards]: HotelFilterInputTypes.Checkbox,
  [HotelFilterTypes.PromotionalRates]: HotelFilterInputTypes.Radio,
  [HotelFilterTypes.CheckinTimes]: HotelFilterInputTypes.Checkbox,
  [HotelFilterTypes.Score]: HotelFilterInputTypes.Checkbox,
};

export const HOTEL_FILTERS_TITLES = {
  [HotelFilterTypes.Category]: 'HOTEL_FILTER_BAR.TAGS.CATEGORIES',
  [HotelFilterTypes.Zones]: 'HOTELS_MODULE.FILTER_HOTELS.LOCATION',
  [HotelFilterTypes.Price]: 'FLIGHT_RESULTS_MODULE.FILTER_SECTION.PRICE_NIGHT',
  [HotelFilterTypes.HotelPriceRanges]: 'HOTELS_MODULE.FILTER_HOTELS.HOTEL_PRICE_RANGES',
  [HotelFilterTypes.NonRefundable]: 'HOTELS_MODULE.FILTER_HOTELS.REFUNDABLE',
  [HotelFilterTypes.Ammenities]: 'HOTELS_MODULE.FILTER_HOTELS.AMMENITIES',
  [HotelFilterTypes.HotelName]: 'HOTELS_MODULE.FILTER_HOTELS.NAME_HOTEL',
  [HotelFilterTypes.Tags]: 'HOTELS_MODULE.FILTER_HOTELS.TAGS',
  [HotelFilterTypes.Boards]: 'HOTELS_MODULE.FILTER_HOTELS.BOARDS',
  [HotelFilterTypes.PromotionalRates]: 'HOTELS_MODULE.FILTER_HOTELS.PROMOTIONAL_RATES',
  [HotelFilterTypes.PackHours]: 'HOTELS_MODULE.FILTER_HOTELS.PACK_HOURS',
  [HotelFilterTypes.CheckinTimes]: 'HOTELS_MODULE.FILTER_HOTELS.CHECK_IN_TIMES',
  [HotelFilterTypes.Score]: 'HOTELS_MODULE.FILTER_HOTELS.SCORES',
};

export const HOTEL_FILTERS_PLACEHOLDER = {
  [HotelFilterTypes.HotelName]: 'HOTELS_MODULE.FILTER_HOTELS.PLACEHOLDER_SEARCH'
};

export const HOTEL_NON_REFUNDABLE_TITLES = {
  [NonRefundableTypes.Refundable]: 'HOTELS_MODULE.FILTER_HOTELS.REFUNDABLES.REFUNDABLE',
  [NonRefundableTypes.NonRefundable]: 'HOTELS_MODULE.FILTER_HOTELS.REFUNDABLES.NO_REFUNDABLE'
};

export const DISABLED_FILTER_MULTIPLE_OPTIONS = {
  [HotelFilterTypes.HotelPriceRanges]: true,
  [HotelFilterTypes.NonRefundable]: true
};

